import jwt from 'jsonwebtoken';
import type { DecodedToken } from 'interface/token';

/**
 * Decoded the passed token and return decoded token.
 *
 * @param token
 */
export function getDecodedToken(token: string | null | undefined): DecodedToken | null {
  try {
    return jwt.decode(token);
  } catch {
    return null;
  }
}
